;(function ($) {
  $(document).ready(function () {
    // this function shoulx add the error text, the element to the input-row and add a inputError class to the input
    function createErrorElement(input, error) {
      const errorElement = `<div class="error">${error}</div>`
      const $inputRow = input.closest(".input-row")

      // Append the error element to the input-row
      $inputRow.append(errorElement)

      // Add the inputError class to the input
      input.addClass("inputError")
    }

    function removeErrorElement($element) {
      $element.removeClass("inputError")
      $element.closest(".input-row").find(".error").remove()
    }

    $(".form-newsletter form").on("submit", function (e) {
      e.preventDefault()
      const $form = $(this)
      const $button = $form.find(".button")
      const $message = $form.find(".form-newsletter__message")
      const $email = $form.find('input[name="email"]')
      const $accept = $form.find('input[name="accept-newsletter"]')
      const isAccepted = $accept.is(":checked") ? 1 : 0
      const email = $email.val()
      const data = {
        action: "mailchimp_subscribe",
        email: email,
        accept: isAccepted,
      }

      $button.attr("disabled", true)
      removeErrorElement($email)
      removeErrorElement($accept)

      $.ajax({
        type: "POST",
        url: tei_ajax_object.ajax_url,
        data: data,
        success: function (data) {
          $button.attr("disabled", false)
          if (data.success) {
            $(".form-newsletter").html("")
            $(".form-newsletter").html(`<p class="lead">${data.data}</p>`)
          } else {
            if (data.error === "already_subscribed") {
              createErrorElement($email, data.data)
            }
            if (data.error === "invalid_email") {
              createErrorElement($email, data.data)
            }
            if (data.error === "invalid_accept") {
              createErrorElement($accept, data.data)
            }
          }
        },
        error: function (err) {
          $button.attr("disabled", false)
          $message.html("Error: Please contact us!")
          console.log("Error: ", err)
        },
      })
    })
  })
})(jQuery)
